module.exports = __webpack_public_path__ + "static/img/google-rating.98ca918.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/google-rating.png
// module id = V5kK
// module chunks = 1